function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 247.9h21.1c.2 21.4 14.3 35.6 35.1 35.6 21.6 0 35.8-14.7 35.8-35.6h99.3c.2 21.4 14.3 35.5 35.1 35.5 21.6 0 35.8-14.6 35.8-35.5h21.3V92H92.1v35.5H50.8L0 178.3v69.6zm120.5-127.5h134.7v99.2H120.5v-99.2zm-28.3 99.2H28.4V190l34.2-34.2h29.6v63.8zM0 0h45.7c19.1 0 32.8 9 32.8 26.5 0 17.6-13.7 26.7-32.8 26.7H22.3V85H0V0zm43.4 36.3c7.5 0 11.9-3 11.9-9.6 0-6.5-4.5-9.6-11.9-9.6H22.3v19.2h21.1z"
})));